module.exports = __webpack_public_path__ + "static/media/logo.4c0272a0.png";